import { combineReducers } from 'redux';

import initialLocation, * as fromInitialLocation from './initialLocation';
import location, * as fromLocation from './location';
import { getPageGroupName, pageGroupReducer as pageGroup } from './pageGroup/reducers';
import user, * as fromUser from './user';

import type { MutationType } from '@web-platform/shared-universal-types/src/network/requestTypes';
import type { AppInitialState } from '@web-platform/shared-universal-types/src/redux/state/appInitial';

export default combineReducers({
  pageGroup,
  initialLocation,
  location,
  user,
});

// pageGroup
export const getPageGroup = (state: AppInitialState) => getPageGroupName(state.pageGroup);

// initialLocation
export const getInitialLocation = (state: AppInitialState) =>
  fromInitialLocation.get(state.initialLocation);

// location
export const getLocation = (state: AppInitialState) => fromLocation.get(state.location);

// user - common selectors
export const getUserDevice = (state: AppInitialState) => fromUser.getDevice(state.user);
export const getUserSession = (state: AppInitialState, key: MutationType) =>
  fromUser.getSession(state.user, key);
export const getUserIdentifiers = (state: AppInitialState) => fromUser.getIdentifiers(state.user);
export const getUserSearch = (state: AppInitialState) => fromUser.getUserSearch(state.user);

// user - Acorn-specific selectors
export const getUserEvents = (state: AppInitialState) => fromUser.getEvents(state.user);

// user - Banana-specific selectors
export const getUserUI = (state: AppInitialState) => fromUser.getUI(state.user);
export const getUserLogin = (state: AppInitialState) => fromUser.getLogin(state.user);
export const getUserTrustedFunnel = (state: AppInitialState) =>
  fromUser.getTrustedFunnel(state.user);
